<template>
  <div class="template">
    <div class="dc-bg"></div>
    <div id="custom_template_thelinedc" class="container shadowed thelinedc">

      <div class="images">
        <img src="./assets/images/logo.png" />
      </div>
      <div class="theme-heading py-20"><h1>DC DIFFERENTLY</h1><p>Welcome to the LINE DC.</p></div>
        <!---REG METHODS BLOCK -->
        <div id="rms" class="rms" v-if="registration_methods.length>0">

          <registration-method
            v-for="(registration_method,index) in registration_methods"
            :key="index"
            v-on:changeSelected="changeSelected"
            v-on:changeSelectedTOS="changeSelectedTOS"
            v-on:emitRegistrationMethodData="emitRegistrationMethodData"
            v-on:error="handleError"
            :portal="portal"
            :index="index"
            :selected="doc.selected_rm"
            :selected_tos="doc.selected_tos"
            :registration_method="registration_method" />
        </div>
        <!-- END REG METHOD BLOCK -->
        <div class="theme-footer text-center text-14 p-30"><p class="mt-0 mb-0"><strong>24/7 Internet Support: </strong> (877) 282-2519</p><p class="mt-0 mb-0"><strong>My Device: </strong> <span id="my_ip">{{connection_data.client_ip}}</span> <span> - </span> <span id="my_mac">{{connection_data.client_mac}}</span></p></div>
    </div>
  </div>

</template>

<script>
import RegistrationMethod from '@/components/custom/thelinedc/PortalRegistrationMethod'

export default {
  name: 'custom_template_thelinedc',
  props: [
    'portal',
    'connection_data'
  ],
  components: {
    'registration-method': RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    'doc.selected_rm': function(){
      this.doc.selected_tos = null;
    },
  },
  data(){
    return{
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: '8772822519',
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>All materials, information, software, products, and services included in or available by the hotel are provided "as is". the hotel, its subsidiaries, affiliates, owner, and its representatives accept no liability for any problems associated with your use of the services, including, but not limited to, damage to your software, hardware, or other equipment; any delay in operation or transmission of the services; any communications line failure, theft or destruction; any problems or technical malfunction of any telephone network or lines, computer on-line systems, servers, providers, or computer equipment; or any traffic congestion of failure of the internet or any web site. The services are provided without warranties of any kind, either express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, or noninfringement. The hotel, its subsidiaries, affiliates, owner, and its representatives do not warrant that the services are accurate, reliable or correct; that the services will be uninterrupted or available at any particular time or location; that the services are secure or that any wireless or wired connection will not be accessed, intercepted, altered or destroyed in whole or in part by an unauthorized third party; that any data files, programs, procedures or information (including your personally identifiable information) downloaded, recorded, transmitted or input through the services will be secure or protected from unauthorized access to, alteration, deletion, defect or destruction; that any defects or errors will be corrected; or that the content or services are free of viruses or other harmful components. Some jurisdictions do not permit the exclusion of certain warranties, so these exclusions may not apply to you.<br><br><b>LIMITATION OF LIABILITY</b><br>Under no circumstances shall the hotel, its subsidiaries, affiliates, owner or its representatives be liable for any direct, indirect, punitive, incidental, special, or consequential damages that result from the use of or inability to use, the services. This limitation applies even if the hotel has been advised of the possibility of such damage. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the hotel's liability in such jurisdictions shall be limited to the maximum extent permitted by law.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    }
  },
  filters: {
    phone: function (value) {
      if (!value) return '';
      value = value.toString();
      return '(' + value.substr(0,3) + ') ' + value.substr(3,3) + '-' + value.substr(6,4);
    }
  },
  mounted(){
    if(this.portal.template.support_phone){
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();
  },
  methods: {
    handleError:function(error){
      this.$emit('emitCustomError',error);
    },
    generateRegistrationMethods:function(){
      for(var i in this.portal.registration_methods){
        var rm = this.portal.registration_methods[i];
        for(var c in rm.rate_plans){
          var rateplan = rm.rate_plans[c];
          var plan = {
            name: rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: 'rateplan',
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if(this.portal.access_codes.length>0){
        plan = {
          name: 'Access Code',
          type: 'accesscode',
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if( this.registration_methods.length == 1 ){
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function(index){
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function(index){
      this.doc.selected_tos = index;
    },
    // Send registration method details back to parent
    emitRegistrationMethodData:function(emitted){
      // Check the template for v-on:emitRegistrationMethodData
      this.$emit('emitRegistrationMethodData',emitted);
    },

  }
}
</script>
<style>
.images {
  padding: 1rem;
}

.dc-bg {
  background-image: url(assets/images/bg.jpg);
  height: 100%;
  position: fixed;
  z-index: -1;
  bottom:0;
  width:100%;
  background-size: cover;
  background-repeat: no-repeat;
}

.template {
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
